module.exports = __webpack_public_path__ + "img/20250219-01-02.4f47310f.png";